<main class="container py-5">
  <div class="row g-4 align-items-center">
    <div class="col-md-6">
      <div class="custom-grid">
        <div class="form top-left-rounded"></div>
        <div class="form-sm rounded-all"></div>
        <div class="form img top-right-rounded">
          <img src="/assets/img/home_image_3.png" alt="" />
        </div>

        <div class="form-md bottom-left-rounded"></div>
        <div class="form img top-right-rounded">
          <img src="/assets/img/home_image_3.png" alt="" />
        </div>
        <div class="form-md bottom-right-rounded"></div>

        <div class="form img bottom-left-rounded">
          <img src="/assets/img/home_image_3.png" alt="" />
        </div>
        <div class="form-md bottom-right-rounded"></div>
        <div class="form-sm rounded-all"></div>
      </div>
    </div>

    <div class="col-md-6">
      <p class="text-muted mb-1">Acerca de</p>
      <h1 class="display-5 fw-bold">
        Universidad del
        <br />
        Deporte
      </h1>
      <p class="mt-3 text-muted">
        En la Universidad del Deporte del Estado de Puebla creemos que formar
        seres humanos a través del deporte comienza mucho antes del aula. Por
        eso, impulsamos tres grandes ACCIONES que conectan nuestra visión con la
        niñez y juventud poblana, sembrando desde ahora el carácter, la
        disciplina y los sueños que forjarán a las próximas generaciones.
      </p>

      <ul class="nav nav-tabs mt-4" id="aboutTabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            data-bs-toggle="tab"
            data-bs-target="#tab1"
            type="button"
            role="tab"
          >
            Nuestro Escudo
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            data-bs-toggle="tab"
            data-bs-target="#tab2"
            type="button"
            role="tab"
          >
            Mensaje del Rector
          </button>
        </li>
      </ul>
    </div>
  </div>

  <div class="mt-5 tab-content">
    <div class="tab-pane fade show active" id="tab1" role="tabpanel">
      <div class="row">
        <div class="col-md-6">
          <div
            class="position-relative d-inline-block my-4 custom-img-wrapper-one"
          >
            <div class="position-absolute bg-shape w-100 h-100 rounded-5"></div>
            <img
              src="/assets/img/tab1.png"
              alt=""
              class="img-fluid rounded-5 position-relative shadow-sm z-1"
            />
          </div>
        </div>

        <div
          class="col-md-6"
          style="text-align: justify; border-left: 1px solid #dee2e6"
        >
          <h5 class="mt-3 text-primary">
            <i class="bi bi-caret-right-fill"></i>
            Nuestro Escudo
          </h5>

          <p class="text-muted">
            El escudo de la Universidad del Deporte de Puebla representa más que
            una identidad visual: es el símbolo de una institución comprometida
            con transformar la educación y el deporte en herramientas para
            formar personas con carácter, valores y propósito.
          </p>

          <p class="text-muted">
            Concebido como una historia de futuro, voluntad y esperanza, el
            escudo integra cuatro elementos esenciales. El primero es el
            movimiento, entendido como un lenguaje universal del cuerpo y una
            muestra de la capacidad humana para adaptarse y avanzar. También se
            incorpora el Popocatépetl, ícono natural de Puebla, que refleja la
            fortaleza y resistencia de sus habitantes. Un tercer símbolo es el
            mazo, representación del esfuerzo, la disciplina y la dedicación
            necesarias en la formación académica y deportiva. Finalmente, la
            semilla simboliza el potencial, el crecimiento y la grandeza que
            pueden alcanzarse cuando se trabaja con pasión.
          </p>

          <p class="text-muted">
            Los colores verdes, rojos y cafés aportan una conexión con el
            entorno, la energía vital y el coraje de una comunidad universitaria
            que comienza su camino. El escudo refleja el compromiso de la UDEP
            con sus primeras generaciones de estudiantes, en especial con
            quienes provienen del interior del estado.
          </p>
        </div>
      </div>
    </div>

    <div class="tab-pane fade" id="tab2" role="tabpanel">
      <div class="row">
        <div class="col-md-6">
          <div
            class="position-relative d-inline-block my-4 custom-img-wrapper-two"
          >
            <div class="position-absolute bg-shape w-100 h-100 rounded-5"></div>
            <img
              src="/assets/img/tab2.jpeg"
              alt=""
              class="img-fluid rounded-5 position-relative shadow-sm z-1"
            />
          </div>
        </div>

        <div
          class="col-md-6"
          style="text-align: justify; border-left: 1px solid #dee2e6"
        >
          <h5 class="mt-3 text-primary">
            <i class="bi bi-caret-right-fill"></i>
            Mensaje del Rector
          </h5>

          <p class="text-muted">
            La Universidad del Deporte del Estado de Puebla no es solo un
            proyecto académico. Es una causa. Es una fuerza viva. Es un grito de
            esperanza que parte del corazón del deporte y se extiende hasta el
            alma de cada comunidad poblana.
          </p>

          <p class="text-muted">
            Porque aquí creemos que el deporte no es un lujo, es una necesidad.
            No es un privilegio, es un derecho. No es un pasatiempo, es una
            poderosa herramienta de transformación. La UDEP nace para eso: para
            mantener a Puebla en movimiento. Porque cuando nos movemos —cuando
            corremos, sudamos, luchamos— también movemos algo más profundo:
            nuestra conciencia, nuestras emociones, nuestros sueños. El deporte
            bien dirigido no solo forma atletas: forma seres humanos completos.
            Y esa es nuestra misión. Queremos que cada poblano —niño, joven,
            mujer, adulto— descubra que el deporte puede ser su camino. Su
            refugio. Su oportunidad. Que moverse no sea una actividad, sino una
            actitud. Una forma de vivir, de resistir, de avanzar.
          </p>

          <p class="text-muted">
            Cuando un joven se mueve con propósito, se aleja de la violencia.
            Cuando una mujer se empodera a través del deporte, una familia
            entera se levanta. Cuando una comunidad se activa, la paz deja de
            ser un discurso y se vuelve una realidad. Por eso, desde la UDEP,
            queremos construir más que licenciados: queremos formar personas de
            bien. Ciudadanos que encuentren en la educación y el deporte el
            equilibrio perfecto para vivir con alegría, con salud, con dignidad.
          </p>

          <p class="text-muted">
            Aquí ofrecemos carreras profesionales, pero también caminos de
            formación continua. Porque la vida no se detiene, y nosotros
            tampoco. Queremos que cada paso, cada entrenamiento, cada clase, sea
            una oportunidad para crecer. Para levantarse. Para creer. Creemos
            firmemente que cuando combinamos el esfuerzo físico con la educación
            del alma, estamos construyendo algo mucho más grande que un campus o
            un título: estamos construyendo el Puebla que todos queremos. El
            Puebla que todos merecemos.
          </p>

          <p class="text-muted">
            Esto es la UDEP. Un movimiento que no se detiene. Un escudo que
            protege. Una llama que inspira. Un hogar donde el deporte es el
            idioma, pero el verdadero mensaje es claro: Tú puedes.
            <strong>AFERRATE A TU SUEÑO.</strong>
            Y aquí, contigo, ya está sucediendo.
          </p>
        </div>
      </div>
    </div>
  </div>
</main>
